<template>
	<div>
    <div class="HorizontalScroller-styles-container SportFilters-styles-horizontal-scroller" v-if="events">
      <div class="HorizontalScroller-styles-child-container SportFilters-styles-filter-container HorizontalScroller-styles-child-animation">
        <div v-on:click="go('fav')">
          <div testid="SportFilter_soccer" class="SportFilter-styles-sport-filter" :class="($route.query.favOnly) ? 'SportFilter-styles-selected' : ''">
            <span class="SportFilter-styles-amount notranslate"></span>
            <a class="Button-styles-button TabButton-styles-tab-button TabButton-styles-tab-button-active TabButton-styles-tab-button-full-width SportFilter-styles-container" id="tab-button-soccer" testid="Button_tab_button_soccer">
              <div class=""><img class="SportFilter-styles-sport-icon" onerror="this.style.display='none'" src="/static/assets/img/highlights.png" loading="lazy" alt="Sport" width="24" height="24">
                <div class="SportFilter-styles-sport-text SportFilter-styles-selected">Favori</div>
              </div>
            </a>
          </div>
        </div>
        <div v-for="sport in sortAByKey(events, 'order')">
          <div v-on:click="go(sport)">
            <div testid="SportFilter_soccer" class="SportFilter-styles-sport-filter" :class="($route.params.sport === sport.ID) ? 'SportFilter-styles-selected' : ''"><span class="SportFilter-styles-amount notranslate">{{ sport.Count }}</span>
              <a class="Button-styles-button TabButton-styles-tab-button TabButton-styles-tab-button-full-width SportFilter-styles-container" :class="($route.params.sport === sport.ID) ? 'TabButton-styles-tab-button-active ' : ''" id="tab-button-soccer" :title="sport.Sport" href="javascript:;">
                <div class=""><img class="SportFilter-styles-sport-icon" onerror="this.style.display='none'" :src="'/static/assets/img/'+sport.Alias+'.png'" loading="lazy" alt="Sport" width="24" height="24">
                  <div class="SportFilter-styles-sport-text SportFilter-styles-selected">{{ sport.Sport }}</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>


	</div>
</template>

<script>
	import Swiper from 'swiper/dist/js/swiper.js'
    import sportIcon from '@/components/ui/asset/sportIcon';
    export default {
        name: 'sportToolbar',
	    components: {sportIcon},
	    props: {
			onlive: {
				default: null
			},
			autoRewrite: {
				default: false
			}
	    },
		data() {
			return {
				sport: 0,
				events: null,
				swiperOption: {
					slidesPerView: 6,
					spaceBetween: 0,
					// init: false,
					allowTouchMove: false,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
				}
			}
		},
		beforeDestroy() {
			clearInterval(window.EventIntervalToolbar);
		},
	    mounted () {
			clearInterval(window.EventIntervalToolbar);
			window.EventIntervalToolbar = setInterval(this.fetchEvents, 50000);
			this.fetchEvents();
	    },
		computed: {
			sw() {
				return this.$refs.sw
			},
		},
		methods: {
        go (sport) {

          if(sport === 'fav'){

            if(!this.$route.query.favOnly){
              this.$router.push({ name: 'LiveBets', params: { sport: sport.ID }, query: {favOnly: 1} })
            }else {
              this.$router.push({ name: 'LiveBets', params: { sport: sport.ID }, query: {favOnly: null} })
            }
            window.location.reload()
          }else {

            if(this.$route.params.sport === sport.ID){
              this.$router.push({ name: 'LiveBets', params: { sport: this.sport } })
            }else {
              this.$router.push({ name: 'LiveBets', params: { sport: sport.ID } })
            }
          }


			},

        	async fetchEvents () {
				if(window.windowFocused){
					await this.$http.get(bsapi + 'api/v2/fixture/count?onLive=1', {
						params: {
							app: this.$root.app.id,
							withoutMatch: 1,
							onLive: this.onlive,
							per_page: 999999999,
							app: this.$root.app.id,
							locale: window.locale
						}
					}).then(response => {
						// get body data

						this.events = response.body.result;
						this.sport = this.events[0].ID;


						if(this.autoRewrite && !this.$route.query.favOnly){
							this.$router.push({ name: 'LiveBets', params: { sport: this.sport }, query: null})
						}
							


					}, response => {

					})
				}
			}
		}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

	.swiper-button-disabled {
		display: none;
	}
	.swiper-container {
		width: 100%;
		border-bottom: 3px solid #f64835;
	}

	.nav-item {
		font-size: 12px
	}
	i {
		font-size: 12px;
		display: none;
	}

	.tabs-style-iconbox nav ul li {
		margin: 0;
		width: 100%;
		height: 35px;
	}

	.tabs-style-iconbox nav ul li a {
		width: 100%;
		float: left;
		display: block;
		font-size: 13px;
		color: #666;
		font-size: 16px;
	}
	.tabs-style-iconbox nav ul li.tab-current a{
		color: white;

	}
	.swiper-button-next, .swiper-container-rtl .swiper-button-prev {
		right: 0;
	}
	.tabs-style-iconbox nav ul li:first-child::before, .tabs-style-iconbox nav ul li::after {
		height: 100%;
		top: 0;
	}
</style>




// WEBPACK FOOTER //
// src/components/sportsbook/sportToolbar.vue